// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"PageIcons_iconContainer__DPMK6","container":"PageIcons_container__gBe_v","details":"PageIcons_details__JsPlR"};